<template>
  <div class="flex flex-col">
    <MglMap
      style="width:100%"
      :style="{'height': maxHeight}"
      ref="map"
      :accessToken="accessToken"
      :mapStyle="mapStyle"
      :center="center"
      :zoom="zoom"
      @load="onMapLoad"
      @idle="onMapIdle"
      flex
    >
      <MglGeojsonLayer
        :layerId="perimeterLineId"
        :sourceId="sourceId"
        :source="geoJsonSource"
        :layer="geoJsonLineLayer"
      />
      <MglGeojsonLayer
        :layerId="perimeterFillId"
        :sourceId="sourceId"
        :source="geoJsonSource"
        :layer="geoJsonFillLayer"
      />
      <MglNavigationControl position="top-right"/>
      <MglGeolocateControl position="top-right"/>
      <MglMarker
        v-for="(marker, index) in stores"
        :key="marker.code"
        :coordinates="marker.position"
        :color="markerColor(marker)"
        :draggable="marker.draggable"
        ref="stores"
        @click="(event) => markerClick(index, event)"
        @dragend="dragEnd"
      >
        <MglPopup :offset="{bottom: [0, -12]}" :maxWidth="popupMaxWidth">
          <vx-card>
            <div>
              <b>{{ marker.name }}</b>
              <p class="hidden md:flex">{{ marker.address }}</p>
              <div v-if="marker.type == 'store'">
                <p v-if="marker.carryOut">
                  <span v-if="marker.detailCarryHours">
                    <b class="hidden md:flex">Horario de atención en tienda:</b>
                    <b class="flex md:hidden">Horario atención tienda:</b>
                    <table>
                      <tr>
                        <td v-for="(hour, index) in marker.carryOutHours" :key="index" style="padding-right: 12px;">
                          {{ hour.title }}
                          <br>
                          {{ hour.hours }}
                        </td>
                      </tr>
                    </table>
                  </span>
                  <span v-else>Horario de atención en tienda: {{ marker.carryTime }}</span>
                </p>
                <p v-else>Esta tienda no ofrece atención en tienda</p>

                <p v-if="marker.delivery">
                  <span v-if="marker.detailDeliveryHours">
                    <b class="hidden md:flex">Horario de servicio a domicilio:</b>
                    <b class="flex md:hidden">Horario domicilio:</b>
                    <table>
                      <tr>
                        <td v-for="(hour, index) in marker.deliveryHours" :key="index" style="padding-right: 12px;">
                          {{ hour.title }}
                          <br>
                          {{ hour.hours }}
                        </td>
                      </tr>
                    </table>
                  </span>
                  <span v-else>Horario de servicio a domicilio: {{ marker.deliveryTime }}</span>
                </p>
                <p v-else>
                  <span class="hidden md:flex">Esta tienda no ofrece servicio a domicilio</span>
                  <span class="flex md:hidden">No se ofrece servicio a domicilio</span>
                </p>
              </div>
            </div>
            <div slot="footer" v-if="marker.type == 'store' && (checkDelivery(marker) || checkCarry(marker))">
              <div class="p-2 flex items-center justify-between">
                <vs-button size="small" class="mr-2" v-if="checkDelivery(marker)" @click="setSelectedStore(marker, 'delivery')">A domicilio</vs-button>
                <vs-button size="small" v-if="checkCarry(marker)" @click="setSelectedStore(marker, 'carryOut')">Recoger en tienda</vs-button>
              </div>
            </div>
          </vx-card>
        </MglPopup>
      </MglMarker>
    </MglMap>
    <div class="flex md:hidden flex-col my-2">
      <h4>{{ currentMarker.name }}</h4>
      <span>{{ currentMarker.address }}</span>
      <span>{{ currentMarker.cityName }}, {{ currentMarker.stateName }}</span>
    </div>
  </div>
</template>

<script>
import Mapbox from "mapbox-gl";
import {MglMap, MglNavigationControl, MglGeolocateControl, MglMarker, MglPopup, MglGeojsonLayer} from "vue-mapbox";

export default {
  name: "MapboxMap",
  props: {
    center: Array,
    zoom: Number,
    stores: Array,
    perimeter: Array
  },
  components: {
    MglMap,
    MglNavigationControl,
    MglGeolocateControl,
    MglMarker,
    MglPopup,
    MglGeojsonLayer
  },
  data() {
    return {
      sourceId: 'perimeterSource',
      perimeterLineId: 'perimeterLineLayer',
      perimeterFillId: 'perimeterFillLayer',
      mapReady: false,
      pendingTasks: [],
      geoJsonSource: {
        type: 'geojson',
        data: {
          id: 'perimeterSource',
          type: "FeatureCollection",
          features: []
        }
      },
      geoJsonLineLayer: {
        type: "line",
        paint: {
          "line-color": "black",
          'line-width': 2
        },
      },
      geoJsonFillLayer: {
        type: "fill",
        paint: {
          'fill-color': '#ED6D3A', // blue color fill
          'fill-opacity': 0.1
        }
      },
      storePerimeter: [],
      defaultMapLayers: null,
      currentMarker: {
        name: '',
        address: '',
        cityName: '',
        stateName: ''
      }
    };
  },
  watch: {
    mapReady: function () {
      if (this.mapReady) {
        while (this.pendingTasks.length > 0) {
          const task = this.pendingTasks.pop();
          if (task.task == 'flyTo') {
            this.flyTo(task.data)
          }
        }
      }
    }
  },
  computed: {
    accessToken() {
      return this.$store.getters['getParameter']('mapbox').accessToken;
    },
    mapStyle() {
      return this.$store.getters['getParameter']('mapbox').mapStyle;
    },
    polygon() {
      const perimeter = [];
      for (let i = 0; i < this.storePerimeter.length; i++) {
        perimeter.push([parseFloat(this.storePerimeter[i].split(',')[0]), parseFloat(this.storePerimeter[i].split(',')[1])])
      }
      return perimeter;
    },
    popupMaxWidth() {
      return '200px';
    },
    maxHeight() {
      let height = "600px";
      if (this.$store.state.windowWidth < 768) {
        height = "400px";
      }
      return height;
    }
  },
  created() {
    this.mapbox = Mapbox;
    this.map = null;
  }
  ,
  methods: {
    onMapLoad(event) {
      this.map = event.map;
    },
    onMapIdle() {
      this.mapReady = true;
    },
    setZoom(zoom) {
      this.map.setZoom(zoom);
    },
    setCenter(center) {
      this.map.setCenter(center);
    },
    markerColor(marker) {
      let color = 'black';
      if (marker.type == 'store') {
        color = '#ED6D3A';
      }
      return color;
    },
    /*
        markStores() {
          if (this.stores.length > 0) {
            const H = window.H;
            const icon = new H.map.Icon(require('../../assets/images/anfora_marker.png'), {size: {w: 50, h: 63}});
            const ui = H.ui.UI.createDefault(this.map, this.defaultMapLayers);
            for (let i = 0; i < this.stores.length; i++) {
              const marker = new H.map.Marker({lat: this.stores[i].position.lat, lng: this.stores[i].position.lng}, {icon: icon});
              marker.setData(`<p>${this.stores[i].name}</p>`);
              marker.addEventListener('tap', event => {
                const bubble = new H.ui.InfoBubble(
                  event.target.getPosition(),
                  {
                    content: event.target.getDate()
                  }
                );
                ui.addBuble(bubble);
              }, false);
              this.map.addObject(marker);
            }
          }
        },
    */
    markStores(stores) {
      if (stores.length > 0) {
        const map = this.map;
        const H = window.H;
        const icon = new H.map.Icon(require('../../assets/images/anfora_marker.png'), {size: {w: 50, h: 63}});
        const ui = H.ui.UI.createDefault(this.map, this.defaultMapLayers);
        for (let i = 0; i < stores.length; i++) {
          const marker = new H.map.Marker({lat: stores[i].position.lat, lng: stores[i].position.lng}, {icon: icon});
          marker.setData(`<p>${stores[i].name}</p>`);
          marker.addEventListener('tap', event => {
            map.setCenter(event.target.getGeometry());
            const bubble = new H.ui.InfoBubble(
              event.target.getGeometry(),
              {
                content: event.target.getData()
              }
            );
            ui.addBubble(bubble);
            bubble.open();
          }, false);
          map.addObject(marker);
        }
      }
    },
    showPerimeter() {
      if (this.perimeter.length > 0) {
        const H = window.H;
        const linestring = new H.geo.LineString();
        for (let i = 0; i < this.perimeter.length; i++) {
          linestring.pushPoint({lat: parseFloat(this.perimeter[i].split(',')[1]), lng: parseFloat(this.perimeter[i].split(',')[0])})
        }
        const polygon = new H.map.Polygon(linestring, {style: {fillColor: 'rgba(255, 255, 255, 0.5)', lineWidth: 2}});
        this.map.addObject(polygon);
        this.map.getViewModel().setLookAtData({bounds: polygon.getBoundingBox()});
      }
    }
    ,
    checkCarry(store) {
      var ret = false;
      if (store.carryOut && store.carryOutHoursArray instanceof Array) {
        const now = new Date();
        const dow = now.getDay();
        // const open = parseInt(store.carryOutOpenHour.split(':')[0]);
        // const close = parseInt(store.carryOutCloseHour.split(':')[0]);
        // const closeHour = parseInt(store.carryOutCloseHour.split(':')[1]);
        const open = parseInt(store.carryOutHoursArray[dow].open.split(':')[0]);
        const close = parseInt(store.carryOutHoursArray[dow].close.split(':')[0]);
        const closeHour = parseInt(store.carryOutHoursArray[dow].close.split(':')[1]);
        if (now.getHours() >= open) {
          if (now.getHours() < close) {
            ret = true;
          } else if (now.getHours() == close && now.getMinutes() < closeHour) {
            ret = true;
          }
        }
      }
      return ret;
    },
    checkDelivery(store) {
      var ret = false;
      if (store.delivery && store.deliveryHoursArray instanceof Array) {
        const now = new Date();
        const dow = now.getDay();
        // const open = parseInt(store.deliveryOpenHour.split(':')[0]);
        // const close = parseInt(store.deliveryCloseHour.split(':')[0]);
        // const closeHour = parseInt(store.deliveryCloseHour.split(':')[1]);
        const open = parseInt(store.deliveryHoursArray[dow].open.split(':')[0]);
        const close = parseInt(store.deliveryHoursArray[dow].close.split(':')[0]);
        const closeHour = parseInt(store.deliveryHoursArray[dow].close.split(':')[1]);
        if (now.getHours() >= open) {
          if (now.getHours() < close) {
            ret = true;
          } else if (now.getHours() == close && now.getMinutes() < closeHour) {
            ret = true;
          }
        }
      }
      return ret;
    },
    setSelectedStore(store, deliveryType) {
      this.$store.dispatch('updateDeliveryType', deliveryType);
      this.$store.dispatch('updateSelectedStore', store);
      this.$store.dispatch('updateHomeScreen', 2);
      this.$router.push({name: 'shop'});
    },
    flyTo(data) {
      if (this.mapReady) {
        this.map.flyTo(data);
      } else {
        this.pendingTasks.push({task: 'flyTo', data: data});
      }
    },
    togglePopUp(store) {
      const self = this;
      setTimeout(function () {
        if (self.$refs.hasOwnProperty('stores')) {
          for (let i = 0; i < self.$refs.stores.length; i++) {
            if (self.$refs.stores[i].marker._popup.isOpen()) {
              self.$refs.stores[i].togglePopup();
            }
          }
          self.currentMarker = {
            name: '',
            address: '',
            cityName: '',
            stateName: ''
          }
          const idx = self.stores.findIndex(marker => marker.code == store.code);
          if (idx >= 0 && idx < self.$refs.stores.length) {
            if (!self.$refs.stores[idx].marker._popup.isOpen()) {
              self.$refs.stores[idx].togglePopup();
            }
            if (store.type == 'store') {
              self.storePerimeter = store.perimeter;
              self.currentMarker = store;
            }
          }
          if (store.type == 'store') {
            self.markPerimeter();
          }
        }
      }, 500);
    },
    markPerimeter() {
      this.geoJsonSource.data.features = [];
      this.geoJsonSource.data.features.push({
        type: 'Feature',
        geometry: {
          type: 'Polygon',
          coordinates: [this.polygon]
        }
      });
    },
    markerClick(index) {
      this.currentMarker = {
        name: '',
        address: '',
        cityName: '',
        stateName: ''
      }
      this.storePerimeter = [];
      if (index < this.stores.length) {
        this.currentMarker = this.stores[index];
        this.storePerimeter = this.stores[index].perimeter;
      }
      this.markPerimeter();
    },
    dragEnd(args) {
      this.$emit('dragend', args);
    }
  }
};
</script>

<style scoped>
#map {
  width: 55vw;
  min-width: 360px;
  text-align: center;
  background-color: #ccc;
}
</style>
